module.exports = __webpack_public_path__ + "media/images/logout-9da12fcbb6322a432e431429c0645307.svg";